import api from "../../api/index";

const getDispatch = `${process.env.VUE_APP_BASE_URI}/enterprise/dispatch`;
const startDispatch = `${process.env.VUE_APP_BASE_URI}/enterprise/dispatch/start`;
const completeDispatch = `${process.env.VUE_APP_BASE_URI}/enterprise/dispatch/complete`;
const getDispatchByTrackingId = `${process.env.VUE_APP_BASE_URI}/enterprise/trackDispatch`;
const trackDispatchByDevice = `${process.env.VUE_APP_BASE_URI}/enterprise/trackDispatchDevice`;
const searchContact = `${process.env.VUE_APP_BASE_URI}/enterprise/contact`;

// see here
const contactURL = `${process.env.VUE_APP_BASE_URI}/contacts`;
const orderUrl = `${process.env.VUE_APP_BASE_URI}/orders`;

const driverURL = `${process.env.VUE_APP_BASE_URI}/drivers`;
const vehicleURl = `${process.env.VUE_APP_BASE_URI}/vehicles`;

const shipmentsURL = `${process.env.VUE_APP_BASE_URI}/shipments`;
const originURL = `${process.env.VUE_APP_BASE_URI}/shipments/origin`;
const destinationURL = `${process.env.VUE_APP_BASE_URI}/shipments/destination`;
const portUrl = `${process.env.VUE_APP_BASE_URI}/shipments/port`;

const partnerURL = `${process.env.VUE_APP_BASE_URI}/partners`;

const getDefaultState = () => {
  return {
    // dispatchRecords: [],
    // singleDispatch: [],
    // dispatchByTrackId: [],
    // dispatchByDevice: [],
    // searchContact: [],

    // see here
    meta: {},
    contacts: [],
    orders: [],
    ordersMeta: {},
    summary: {},
    order: {},
    trackingDetails: {},
    trackingHistory: [],
    trackHistoryMeta: {},
    trackHistoryChart: [],
    trackHistoryMapPoints: {},

    drivers: [],
    vehicles: [],

    driverDetails: {},
    driverSummary: {},
    driverOrder: {},

    origins: {},
    shipments: {},
    destinations: {},

    shipmentSummary: {},

    selectedId: null,
    insurancePlans: [],

    devicesByStatus: [],

    partners: {},
    shipmentType: null,
    ports: null,
  };
};

const state = getDefaultState();

const getters = {
  dispatchRecords: (state) => state.dispatchRecords,
  singleDispatch: (state) => state.singleDispatch,
  dispatchByTrackId: (state) => state.dispatchByTrackId,
  dispatchByDevice: (state) => state.dispatchByDevice,
  searchContact: (state) => state.searchContact,

  // see here
  contacts: (state) => state.contacts,
  meta: (state) => state.meta,
  orders: (state) => state.orders,
  ordersMeta: (state) => state.ordersMeta,
  orderSummary: (state) => state.summary,
  singleOrder: (state) => state.order,
  trackingDetails: (state) => state.trackingDetails,
  trackingHistory: (state) => state.trackingHistory,
  trackHistoryMeta: (state) => state.trackHistoryMeta,
  trackHistoryChart: (state) => state.trackHistoryChart,
  trackHistoryMapPoints: (state) => state.trackHistoryMapPoints,

  drivers: (state) => state.drivers,
  vehicles: (state) => state.vehicles,

  driverDetails: (state) => state.driverDetails,
  driverSummary: (state) => state.driverSummary,
  driverOrder: (state) => state.driverOrder,

  origins: (state) => state.origins,
  shipments: (state) => state.shipments,
  destinations: (state) => state.destinations,

  shipmentSummary: (state) => state.shipmentSummary,

  selectedId: (state) => state.selectedId,

  insuranceplans: (state) => state.insuranceplans,

  devicesByStatus: (state) => state.devicesByStatus,
  getShipmentType: (state) => state.shipmentType,

  partners: (state) => state.partners,
};

const actions = {
  async getDispatchRecords({ commit }) {
    commit("getDispatchRecords_request");
    const res = await api.get(getDispatch);
    if (res.data.status === "success") {
      commit("getDispatchRecords_success", res.data.data);
    }
    return res;
  },
  async getDispatchRecordById({ commit }, id) {
    commit("getDispatchRecordById_request");
    const res = await api.get(`${getDispatch}/${id}`);
    if (res.data.status === "success") {
      commit("getDispatchRecordById_success", res.data.data);
    }
    return res;
  },
  async trackDispatch({ commit }, id) {
    commit("trackDispatch_request");
    const res = await api.get(`${getDispatchByTrackingId}/${id}`);
    if (res.data.status === "success") {
      commit("trackDispatch_success", res.data.data);
    }
    return res;
  },
  async trackDispatchDevice({ commit }, { id, imei }) {
    commit("trackDispatchDevice_request");
    const res = await api.get(`${trackDispatchByDevice}/${id}/${imei}`);
    if (res.data.status === "success") {
      commit("trackDispatchDevice_success", res.data.data);
    }
    return res;
  },
  async searchContact({ commit }, text) {
    commit("searchContact_request");
    const res = await api.get(`${searchContact}/${text}`);
    if (res.data.status === "success") {
      commit("searchContact_success", res.data.data);
    }
    return res;
  },

  async createDispatch({ commit }, data) {
    commit("createDispatch_request");
    const res = await api.post(getDispatch, data);
    if (res.data.status === "success") {
      commit("createDispatch_success");
    }
    return res;
  },
  async startDispatch({ commit }, id) {
    commit("startDispatch_request");
    const res = await api.put(`${startDispatch}/${id}`);
    if (res.data.status === "success") {
      commit("startDispatch_success");
    }
    return res;
  },
  async completeDispatch({ commit }, id) {
    commit("completeDispatch_request");
    const res = await api.put(`${completeDispatch}/${id}`);
    if (res.data.status === "success") {
      commit("completeDispatch_success");
    }
    return res;
  },

  // see here
  async getContacts({ commit }, params) {
    const res = await api.get(contactURL, { params });
    if (res.data.success) {
      commit("getContacts_success", res.data.payload);
    }
    return res;
  },

  async addContacts({ commit }, newContact) {
    const res = await api.post(contactURL, newContact);
    if (res.data.success) {
      commit("addContacts_success");
    }
    return res;
  },

  async editContact({ commit }, { newContact, id }) {
    const res = await api.patch(`${contactURL}/${id}`, newContact);
    if (res.data.success) {
      commit("editContact_success");
    }
    return res;
  },

  async deleteContact({ commit }, id) {
    const res = await api.delete(`${contactURL}/${id}`);
    if (res.data.success) {
      commit("deleteContact_success");
    }
    return res;
  },

  async validateOrder(_, payload) {
    const res = await api.post(`${orderUrl}/validate`, payload);
    return res;
  },

  async addOrder(_, payload) {
    const res = await api.post(orderUrl, payload);
    return res;
  },

  async getOrders({ commit }, params) {
    const res = await api.get(orderUrl, { params });
    if (res.data.success) {
      commit("getOrders_success", res.data.payload);
    }
    return res;
  },

  async getOrderSummary({ commit }) {
    const res = await api.get(`${orderUrl}/summary`);
    if (res.data.success) {
      commit("getOrderSummary_success", res.data.payload);
    }
    return res;
  },

  async getSingleOrder({ commit }, id) {
    const res = await api.get(`${orderUrl}/${id}`);
    if (res.data.success) {
      commit("getSingleOrder_success", res.data.payload);
    }
    return res;
  },

  async startOrder(_, { id, trackingCode }) {
    const res = await api.patch(`${orderUrl}/${id}/${trackingCode}/start`);
    return res;
  },

  async endOrder(_, { id, trackingCode }) {
    const res = await api.patch(`${orderUrl}/${id}/${trackingCode}/end`);
    return res;
  },

  async cancelOrder(_, id) {
    const res = await api.patch(`${orderUrl}/${id}/cancel`);
    return res;
  },

  async trackOrder({ commit }, { id, trackingCode }) {
    const res = await api.get(`${orderUrl}/${id}/track/${trackingCode}`);
    if (res.data.success) {
      commit("track_order_success", res.data.payload);
    }
    return res;
  },

  async trackOrderHistory({ commit }, { id, trackingCode, params }) {
    const res = await api.get(
      `${orderUrl}/${id}/track/${trackingCode}/history`,
      { params }
    );
    if (res.data.success) {
      commit("track_order_history_success", res.data.payload);
    }
    return res;
  },

  async trackOrderHistoryChart({ commit }, { id, trackingCode, params }) {
    const res = await api.get(
      `${orderUrl}/${id}/track/${trackingCode}/history/chart`,
      { params }
    );
    if (res.data.success) {
      commit("track_order_history_chart_success", res.data.payload);
    }
    return res;
  },

  async trackOrderHistoryMapPoints({ commit }, { id, trackingCode, params }) {
    const res = await api.get(
      `${orderUrl}/${id}/track/${trackingCode}/history/map-points`,
      { params }
    );
    if (res.data.success) {
      commit("track_order_history_map_points_success", res.data.payload);
    }
    return res;
  },

  async fetchInsurancePlans({ commit }, productWorth) {
    const res = await api.get(`${orderUrl}/enterprise/insurances`, {
      params: { productWorth },
    });
    if (res.data.success) {
      commit("fetchInsurancePlans_success", res.data.payload);
    }
    return res;
  },
  async addDrivers({ commit }, newDriver) {
    const res = await api.post(driverURL, newDriver);
    if (res.data.success) {
      commit("addDrivers_success");
    }
    return res;
  },

  async getDrivers({ commit }, params) {
    const res = await api.get(driverURL, { params });
    if (res.data.success) {
      commit("getDrivers_success", res.data.payload);
    }
    return res;
  },

  async editDriver({ commit }, { newDriver, id }) {
    const res = await api.patch(`${driverURL}/${id}`, newDriver);
    if (res.data.success) {
      commit("editDriver_success");
    }
    return res;
  },

  async deleteDriver({ commit }, id) {
    const res = await api.delete(`${driverURL}/${id}`);
    if (res.data.success) {
      commit("deleteDriver_success");
    }
    return res;
  },

  async addVehicles({ commit }, newVehicle) {
    const res = await api.post(vehicleURl, newVehicle);
    if (res.data.success) {
      commit("addVehicles_success");
    }
    return res;
  },

  async getVehicles({ commit }, params) {
    const res = await api.get(vehicleURl, { params });
    if (res.data.success) {
      commit("getVehicles_success", res.data.payload);
    }
    return res;
  },

  async editVehicle({ commit }, { newVehicle, id }) {
    const res = await api.patch(`${vehicleURl}/${id}`, newVehicle);
    if (res.data.success) {
      commit("editVehicle_success");
    }
    return res;
  },

  async deleteVehicle({ commit }, id) {
    const res = await api.delete(`${vehicleURl}/${id}`);
    if (res.data.success) {
      commit("deleteVehicle_success");
    }
    return res;
  },

  async getDriverDetails({ commit }, driverId) {
    const res = await api.get(`${driverURL}/${driverId}`);
    if (res.data.success) {
      commit("getDriverDetails_success", res.data.payload);
    }

    return res;
  },

  async getDriverDetailsSummary({ commit }, driverId) {
    const res = await api.get(`${driverURL}/${driverId}/summary`);
    if (res.data.success) {
      commit("getDriverDetailsSummary_success", res.data.payload);
    }

    return res;
  },

  async getDriverDetailsOrder({ commit }, { driverId, params }) {
    const res = await api.get(`${driverURL}/${driverId}/orders`, { params });
    if (res.data.success) {
      commit("getDriverDetailsSummaryOrder_success", res.data.payload);
    }
    return res;
  },

  async editDriverDetails({ commit }, { newDriverDetails, driverId }) {
    const res = await api.patch(`${driverURL}/${driverId}`, newDriverDetails);
    if (res.data.success) {
      commit("editDriverDetails_success");
    }
    return res;
  },

  async editDriverDetailsVehicle(
    { commit },
    { newDriverDetailsVehicle, driverId }
  ) {
    const res = await api.patch(
      `${driverURL}/${driverId}/vehicle/assign`,
      newDriverDetailsVehicle
    );
    if (res.data.success) {
      commit("editDriverDetailsVehicle_success");
    }
    return res;
  },

  async unassignDriverDetailsVehicle(
    { commit },
    { unassignedVehicle, driverId }
  ) {
    const res = await api.patch(
      `${driverURL}/${driverId}/vehicle/unassign`,
      unassignedVehicle
    );
    if (res.data.success) {
      commit("unassignDriverDetailsVehicle_success");
    }
    return res;
  },

  async deactivateDriver({ commit }, { deactivateDriver, driverId }) {
    const res = await api.patch(
      `${driverURL}/${driverId}/status`,
      deactivateDriver
    );
    if (res.data.success) {
      commit("deactivateDriver_success");
    }
    return res;
  },

  async getShipments({ commit }, params) {
    const res = await api.get(shipmentsURL, { params });
    if (res.data.success) {
      commit("getShipments_success", res.data.payload);
    }
    return res;
  },

  async getOrigin({ commit }, params) {
    const res = await api.get(originURL, { params });
    if (res.data.success) {
      commit("getOrigin_success", res.data.payload);
    }
    return res;
  },

  async addOrigin({ commit }, newOrigin) {
    const res = await api.post(originURL, newOrigin);
    if (res.data.success) {
      commit("addOrigin_success");
    }
    return res;
  },

  async deleteOrigin({ commit }, id) {
    const res = await api.delete(`${originURL}/${id}`);
    if (res.data.success) {
      commit("deleteOrigin_success");
    }
    return res;
  },

  async editOrigin({ commit }, { newOrigin, id }) {
    const res = await api.patch(`${originURL}/${id}`, newOrigin);
    if (res.data.success) {
      commit("editOrigin_success");
    }
    return res;
  },

  async getDestinations({ commit }, params) {
    const res = await api.get(destinationURL, { params });
    if (res.data.success) {
      commit("getDestinations_success", res.data.payload);
    }
    return res;
  },

  async addDestination({ commit }, newDestination) {
    const res = await api.post(destinationURL, newDestination);
    if (res.data.success) {
      commit("addDestination_success");
    }
    return res;
  },
  async getAllPorts({ commit }, { type, country }) {
    const res = await api.get(`${portUrl}?type=${type}&country=${country}`);
    if (res.data.success) {
      commit("getPorts_success", res.data.payload);
    }
    return res;
  },
  async searchPorts({ commit }, params) {
    const res = await api.get(`${portUrl}`, { params });

    return res;
  },

  async editDestination({ commit }, { newDestination, id }) {
    const res = await api.patch(`${destinationURL}/${id}`, newDestination);
    if (res.data.success) {
      commit("editDestination_success");
    }
    return res;
  },

  async deleteDestination({ commit }, id) {
    const res = await api.delete(`${destinationURL}/${id}`);
    if (res.data.success) {
      commit("deleteDestination_success");
    }
    return res;
  },

  async getShipmentSummary({ commit }) {
    const res = await api.get(`${shipmentsURL}/summary`);
    if (res.data.success) {
      commit("getShipmentSummary_success", res.data.payload);
    }
    return res;
  },

  async addShipment({ commit }, newShipment) {
    const res = await api.post(shipmentsURL, newShipment);
    if (res.data.success) {
      commit("addShipment_success");
    }
    return res;
  },

  async uploadBulkShipment({ commit }, bulkShipment) {
    const res = await api.post(`${shipmentsURL}/bulk-upload`, bulkShipment);
    if (res.data.success) {
      commit("bulkShipment_success");
    }
    return res;
  },
  async downloadReport({ commit }, downloadedReport) {
    const res = await api.post(
      `${shipmentsURL}/download-report`,
      downloadedReport
    );
    if (res.data.success) {
      commit("downloadReport_success");
    }
    return res;
  },
  async updateSelectedId({ commit }, ids) {
    commit("setSelectedId", ids);
  },

  async getDevicesByStatus({ commit }, params) {
    const res = await api.get(`${shipmentsURL}/devices-by-status`, { params });
    if (res.data.success) {
      commit("getDevicesByStatus_success", res.data.payload);
    }
    return res;
  },

  async addPartner({ commit }, newPartner) {
    const res = await api.post(partnerURL, newPartner);
    if (res.data.success) {
      commit("addPartner_success");
    }
    return res;
  },

  async getPartner({ commit }, params) {
    const res = await api.get(partnerURL, { params });
    if (res.data.success) {
      commit("getPartner_success", res.data.payload);
    }
    return res;
  },

  async editPartner({ commit }, { newPartner, id }) {
    const res = await api.patch(`${partnerURL}/${id}`, newPartner);
    if (res.data.success) {
      commit("editPartner_success");
    }
    return res;
  },

  updateShipmentType({ commit }, type) {
    commit("handleChangeShipmentType", type);
  },

  async deletePartner({ commit }, id) {
    const res = await api.delete(`${partnerURL}/${id}`);
    if (res.data.success) {
      commit("deletePartner_success");
    }
    return res;
  },
};

const mutations = {
  getDispatchRecords_request: (state) => (state.status = "loading"),
  handleChangeShipmentType: (state, type) => (state.shipmentType = type),
  getDispatchRecords_success: (state, dispatchRecords) => {
    (state.status = "success"), (state.dispatchRecords = dispatchRecords);
  },
  getDispatchRecordById_request: (state) => (state.status = "loading"),
  getDispatchRecordById_success: (state, singleDispatch) => {
    (state.status = "success"), (state.singleDispatch = singleDispatch);
  },
  trackDispatch_request: (state) => (state.status = "loading"),
  trackDispatch_success: (state, dispatchByTrackId) => {
    (state.status = "success"), (state.dispatchByTrackId = dispatchByTrackId);
  },
  trackDispatchDevice_request: (state) => (state.status = "loading"),
  trackDispatchDevice_success: (state, dispatchByDevice) => {
    (state.status = "success"), (state.dispatchByDevice = dispatchByDevice);
  },
  searchContact_request: (state) => (state.status = "loading"),
  searchContact_success: (state, searchContact) => {
    (state.status = "success"), (state.searchContact = searchContact);
  },

  // see here
  getContacts_success: (state, contactPayload) => {
    state.contacts = contactPayload.data;
    state.meta = contactPayload.meta;
  },

  addContacts_success: (state) => (state.status = "success"),

  editContact_success: (state) => (state.status = "success"),

  getOrders_success: (state, ordersPayload) => {
    state.orders = ordersPayload.data;
    state.ordersMeta = ordersPayload.meta;
  },

  getOrderSummary_success: (state, summary) => {
    state.summary = summary;
  },

  getSingleOrder_success: (state, order) => {
    state.order = order;
  },

  track_order_success: (state, trackingDetails) => {
    state.trackingDetails = trackingDetails;
  },

  track_order_history_success: (state, { meta, data }) => {
    state.trackingHistory = data;
    state.trackHistoryMeta = meta;
  },

  track_order_history_chart_success: (state, data) => {
    state.trackHistoryChart = data;
  },

  track_order_history_map_points_success: (state, data) => {
    state.trackHistoryMapPoints = data;
  },

  addDrivers_success: (state) => (state.status = "success"),

  getDrivers_success: (state, driverPayload) => {
    state.drivers = driverPayload.data;
    state.meta = driverPayload.meta;
  },

  editDriver_success: (state) => (state.status = "success"),

  addVehicles_success: (state) => (state.status = "success"),

  getVehicles_success: (state, vehiclePayload) => {
    state.vehicles = vehiclePayload.data;
    state.meta = vehiclePayload.meta;
  },

  editVehicle_success: (state) => (state.status = "success"),

  getDriverDetails_success: (state, driverDetailsPayload) => {
    state.driverDetails = driverDetailsPayload;
  },

  getDriverDetailsSummary_success: (state, driverDetailsSummaryPayload) => {
    state.driverSummary = driverDetailsSummaryPayload;
  },

  getDriverDetailsSummaryOrder_success: (
    state,
    driverDetailsSummaryOrderPayload
  ) => {
    state.driverOrder = driverDetailsSummaryOrderPayload.data;
    state.meta = driverDetailsSummaryOrderPayload.meta;
  },

  editDriverDetails_success: (state) => (state.status = "success"),

  editDriverDetailsVehicle_success: (state) => (state.status = "success"),

  unassignDriverDetailsVehicle_success: (state) => (state.status = "success"),

  deactivateDriver_success: (state) => (state.status = "success"),

  getShipments_success: (state, shipmentPayload) => {
    state.shipments = shipmentPayload.data;
    state.meta = shipmentPayload.meta;
  },

  getOrigin_success: (state, originPayload) => {
    state.origins = originPayload.data;
    state.meta = originPayload.meta;
  },

  addOrigin_success: (state) => (state.status = "success"),

  editOrigin_success: (state) => (state.status = "success"),

  addDestination_success: (state) => (state.status = "success"),
  getPorts_success: (state, payload) => {
    console.log(payload);
    return (state.ports = payload.data);
  },
  getDestinations_success: (state, destinationsPayload) => {
    state.destinations = destinationsPayload.data;
    state.meta = destinationsPayload.meta;
  },

  editDestination_success: (state) => (state.status = "success"),

  getShipmentSummary_success: (state, shipmentSummary) => {
    state.shipmentSummary = shipmentSummary;
  },

  downloadReport_success: (state) => (state.status = "success"),

  setSelectedId(state, ids) {
    state.selectedId = ids;
  },

  fetchInsurancePlans_success(state, payload) {
    state.insuranceplans = payload;
  },

  getDevicesByStatus_success(state, devices) {
    state.devicesByStatus = devices;
  },

  addPartner_success: (state) => (state.status = "success"),

  getPartner_success: (state, partnerPayload) => {
    state.partners = partnerPayload.data;
    state.meta = partnerPayload.meta;
  },

  editPartner_success: (state) => (state.status = "success"),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
